import React from 'react'

export const NoInfo = (text) => {
    const styles = {
        color: "#0ca39e96",
        textAlign: "center",
    }

    return( <span style={styles}>{text}</span>
    )
}


